/* eslint-disable no-restricted-imports */
import React, { useEffect, useMemo } from "react"
import { Modal } from "react-bootstrap"
import { FormattedMessage } from "react-intl"
import { shallowEqual, useDispatch, useSelector } from "react-redux"
import { ModalProgressBar } from "../../../../../../components/partials/controls"
// import { deactivateService, fetchServices } from "../../store/actions"
import { fetchSpecialties, deactivateSpecialtie } from "../../store/actions"
// import { useServicesUIContext } from "../../context/ServicesUIContext"
import { useSpecialtiesUIContext } from "../../context/SpecialtiesUIContext"


export const SpecialtieDeactivateDialog = ({ params, show, onHide }) => {
  // Services UI Context
  const specialtiesUIContext = useSpecialtiesUIContext()
  const specialtiesUIProps = useMemo(() => {
    return {
      setIds: specialtiesUIContext.setIds,
      queryParams: specialtiesUIContext.queryParams,
    }
  }, [specialtiesUIContext])

  // Services Redux state
  const dispatch = useDispatch()
  const { isLoading, success } = useSelector(
    (state) => ({ isLoading: state.admin.specialtie.isLoading, success: state.admin.specialtie.success }),
    shallowEqual
  )

  // if !id we should close modal
  useEffect(() => {
    if (success.isDeactivated && show) {
      onHide()
      dispatch(fetchSpecialties(specialtiesUIProps.queryParams))
      specialtiesUIProps.setIds([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success, show, specialtiesUIProps])

  const onDedeactivateSpecialtie = () => {
    // server request for deleting service by id
    dispatch(deactivateSpecialtie(params))
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {isLoading && <ModalProgressBar variant="query" />}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          <FormattedMessage id="specialtie.DEACTIVATE.TITLE" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormattedMessage id="specialtie.DEACTIVATE.MSG" />
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-sm btn-light btn-elevate"
          >
            <FormattedMessage id="GENERAL.CANCEL" />
          </button>
          <> </>
          <button
            type="button"
            disabled={isLoading}
            onClick={onDedeactivateSpecialtie}
            className="btn btn-sm btn-danger btn-elevate"
          >
            {isLoading && <span className="px-5 spinner spinner-white"></span>}
            <FormattedMessage id="GENERAL.DEACTIVATE" />
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}


export default SpecialtieDeactivateDialog 
